import { cn } from "@/lib/utils";
import Image from "next/image";

export const ContentSourceImg = ({
    width = 32,
    height = 32,
    imgurl,
    className,
    priority = false,
    ...props
}: {
    width?: number;
    height?: number;
    imgurl: string;
    className?: string;
    priority?: boolean;
}) => {
    return (
        <Image
            className={cn("rounded-md", className)}
            alt="source"
            src={imgurl}
            width={width}
            height={height}
            loader={({ src }) => src + `?w=${width * 3}`}
            preload={priority}
            {...props}
        />
    );
};
